import { createContext, useContext } from 'react';

import type { InAppNotificationSocketStatus } from '@/utils/inAppNotificationSocket';

export type InAppNotificationSocketContextValue = {
  /** `disabled` when the feature is off or there is no user to subscribe for. */
  status: InAppNotificationSocketStatus | 'disabled';
};

const defaultContextValue: InAppNotificationSocketContextValue = {
  status: 'disabled',
};

export const InAppNotificationSocketContext =
  createContext<InAppNotificationSocketContextValue>(defaultContextValue);

export const useInAppNotificationSocketContext = () => {
  return useContext(InAppNotificationSocketContext);
};
